import { isMobileOnly, isTablet } from 'react-device-detect';
export const getParamsClubVW = () => {
	let tc: string;
	if (typeof window !== 'undefined' && typeof window.s !== 'undefined' && typeof window.s.persCmp !== 'undefined') {
		tc = window.s.persCmp;
	} else {
		tc = 'undefined';
	}

	const date = new Date();
	const device = isMobileOnly ? 'mobile' : isTablet ? 'tablet' : 'desktop';
	const location = window.location.href;
	const referalUrl = document.referrer.substring(0, 30);
	const today = date.toISOString().replace('T', ' ').split('.')[0];
	const url = window.location.origin + window.location.pathname;

	return {
		device,
		location,
		referalUrl,
		tc,
		today,
		url,
	};
};
